import LoadMoneyActionType from './loadMoney.types';

export const setLoadAmountDetail = data =>({
    type: LoadMoneyActionType.SET_LOAD_AMOUNT_DETAIL,
    payload: data
})
